import { useEffect } from 'react';
import './Blog.css';
import Header from './components/Header';
import BlogGrid from './components/BlogGrid';
import { NavBar } from '../../utility/navBar/Navbar';
import { Contact } from '../../utility/contact/Contact';

export const Blog = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });
    }, []);

    return (
        <section className="blog">
            <NavBar theme='light' />
            <Header />
            <BlogGrid />
            <Contact />
        </section>
    );
};

export default Blog;
